import React from 'react';
import CustomImage from '../../../components/custom-image';
import { graphql, useStaticQuery } from 'gatsby';

const OilGas = () => {
  return (
    <div className="card">
      <div className="title">
        <div className="icon">
          <CustomImage className="custom-image" imageName="icon-oil-and-gas-lg.png" alt="OilGas" maxWidth="90" />
        </div>
        <div className="text">
          <h4>Oil &amp; Gas</h4>
        </div>
      </div>
      <div className="middle-text">
        <p>Operates</p>
        <h3 className="green-text">26%</h3>
        <p>
          of India’s crude
          <br />
          oil production
        </p>
      </div>
      <div className="bottom-text">
        <p>EBITDA (In INR Cr.)</p>
        <p className="green-text">1,649</p>
      </div>
    </div>
  );
};

export default OilGas;
